import { createClientSharedComposable, getStore } from '@global-store/store'
import type { CustomerStore } from '@shared/global-store/stores/customer/types'
import { oauthAuthorizationRedirect } from '@shared/shop-api/core/oauth2'
import type { Customer } from '@shared/shop-api/customer/types'
import { defineStore } from 'pinia'

export const useCustomerStore = createClientSharedComposable(() =>
  defineStore('customer', {
    state: (): CustomerStore => ({
      customer: null,
      token: null,
      authorizationUrl: oauthAuthorizationRedirect() || null,
    }),

    getters: {
      isLoading: (state) => state.customer === null,
      isAuthenticated: (state) => !!state.customer,

      displayName: (state) =>
        state.customer?.firstName || state.customer?.email?.split('@')?.[0],
    },

    actions: {
      login(token?: CustomerStore['token']) {
        this.token = token || null
      },

      logout() {
        this.customer = null
        this.token = null
      },

      setCustomer(customer?: Customer) {
        this.customer = customer || null
      },

      $reset() {
        this.customer = null
        this.token = null
      },
    },
  })(getStore())
)
